import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { colors } from "../../../../ui/colors";
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left";
import { Layout } from "../../../../ui/layout";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Banner } from "../../../../ui/organisms/banner";
import { MenuItems } from "../../../../ui/organisms/navbar/dto";
import { SuccessPopup } from "../../../../ui/organisms/successPopup";
import { GetReportingById, ReportingCreation, ReportingUpdate, ReportingValidation, resetReportingCreationRequest, resetReportingStateCreationStatus, resetReportingUpdateRequest, resetReportingUpdateStatus, resetReportingValidationStatus, setFromCreationToUpdate, setReportingCustomerId, setReportingIdToUpdate, setReportingOfficerId, setReportingStateReportingId, setUpdateReportingCustomerOtherODC, setUpdateReportingDetails, setUpdateReportingEntryProtocolId, setUpdateReportingNote, setUpdateReportingReportingDate, setUpdateReportingReportingState, setUpdateReportingReportingType, setUpdateReportingSender } from "../slice";
import { AddReportingForms } from "./forms";

export function AddReporting() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const reportingState = useAppSelector(state => state.reporting)
    const userState = useAppSelector(state => state.users)
    const sessionState = useAppSelector(state => state.session)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        dispatch(resetReportingCreationRequest())
        dispatch(resetReportingUpdateRequest())
        dispatch(setReportingCustomerId(sessionState.selected.customerId))
        dispatch(setReportingOfficerId(userState.findMeResponse.id))
    }, [])

    useEffect(() => {
        if (reportingState.reportingCreationStatus === 'successfully' &&
            reportingState.reportingCreationResponse !== undefined
        ) {
            setShowSuccess(true)
            dispatch(resetReportingStateCreationStatus())
            dispatch(setFromCreationToUpdate(true))
            dispatch(GetReportingById(reportingState.reportingCreationResponse))
        }
    }, [reportingState.reportingCreationStatus])

    useEffect(() => {
        if (reportingState.reportingValidationStatus === 'successfully') {
            dispatch(resetReportingValidationStatus())
            !reportingState.fromCreationToUpdate ?
                dispatch(ReportingCreation(reportingState.reportingCreationRequest)) :
                dispatch(ReportingUpdate({ body: reportingState.reportingUpdateRequest, id: reportingState.reportingIdToUpdate }))
        }
    }, [reportingState.reportingValidationStatus])

    useEffect(() => {
        if (reportingState.getReportingByIdStatus === 'successfully' &&
            reportingState.getReportingByIdResponse !== undefined
        ) {
            const data = reportingState.getReportingByIdResponse
            dispatch(setReportingIdToUpdate(data.id))
            dispatch(setReportingStateReportingId(data.id))
            dispatch(setUpdateReportingReportingDate(data.reportingDate))
            dispatch(setUpdateReportingSender(data.sender))
            dispatch(setUpdateReportingCustomerOtherODC(data.customerOtherODC))
            dispatch(setUpdateReportingEntryProtocolId(data.entryProtocolId))
            dispatch(setUpdateReportingReportingState(data.reportingState))
            dispatch(setUpdateReportingReportingType(data.reportingType))
            dispatch(setUpdateReportingDetails(data.details))
            dispatch(setUpdateReportingNote(data.note))
        }
    }, [reportingState.getReportingByIdStatus])

    useEffect(() => {
        if (reportingState.reportingUpdateStatus === 'successfully') {
            dispatch(resetReportingUpdateStatus())
            setShowSuccess(true)
        }
    }, [reportingState.reportingUpdateStatus])

    useEffect(() => {
        if (reportingState.reportingStateCreationStatus === 'successfully' ||
            reportingState.reportingStateDeleteStatus === 'successfully'
        ) {
            setShowSuccess(true)
        }
    }, [reportingState.reportingStateCreationStatus,
    reportingState.reportingStateDeleteStatus
    ])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    if (sessionState.selected.customerId) {
        return (
            <Layout
                menuItem={MenuItems.GESTIONE_CONTROLLO}
                breadcrumbItems={['Gestione Controllo', 'Aggiungi segnalazione']}
                noPaddingLat
                headerLabel="Segnalazioni"
                headerIcon={
                    <ArrowLeftIcon onClick={() => navigate('/segnalazioni')} color={colors.white} />
                }
                headerChildren={
                    <div className="flex items-center h-full w-full justify-end gap-2">
                        <ButtonComponent
                            size={"sm"}
                            iconPosition={"off"}
                            variant={"solid"}
                            label="Salva"
                            color={"orange"}
                            onClick={() => dispatch(ReportingValidation(
                                !reportingState.fromCreationToUpdate ?
                                    reportingState.reportingCreationRequest :
                                    reportingState.reportingUpdateRequest
                            ))}
                        />
                    </div>
                }
            >
                <div className="flex flex-col w-full h-full overflow-hidden">
                    {showSuccess && (
                        <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                            <SuccessPopup
                                active={showSuccess}
                                message="Dati salvati correttamente."
                                onClose={() => setShowSuccess(false)}
                            />
                        </div>
                    )}

                    <div className="flex-1 overflow-hidden overflow-x-hidden">
                        <div className="min-w-0 h-full overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-neutral-50 border-r border-neutral-200">
                            <AddReportingForms />
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CONTROLLO}
            breadcrumbItems={['Gestione Controllo', 'Segnalazioni']}
            noPaddingLat
            headerLabel={'Segnalazioni'}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}